export default __webpack_public_path__ + "static/media/twitter_orange.4bfbc0d5.svg";